import { Calendar as CalendarIcon, MapPin as MapPinIcon } from "react-feather";
import { useInView } from "react-intersection-observer";
import TicketIcon from "src/assets/images/ticket_icon.svg";
import { useTracking } from "../../../contexts/trackingContext";
import AdaptiveEventImage from "../../molecules/AdaptiveEventImage";

const LandscapeItem = ({ event, trackView }) => {
	const { tracker } = useTracking();
	const { ref } = useInView({
		triggerOnce: true,
		skip: !trackView,
		onChange: (inView) => {
			if (trackView && inView) {
				tracker.trackEventView(event, "event_list");
			}
		},
	});

	return (
		<div
			className="overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm h-full w-full"
			ref={ref}
		>
			<a
				href={event.absoluteHref}
				target="_top"
				className="flex h-full flex-col"
			>
				{event.imageUrl && (
					<div className="relative flex h-32 w-full">
						<AdaptiveEventImage
							src={event.imageUrl}
							alt={event.title}
							loading="lazy"
						/>
					</div>
				)}
				<div className="flex flex-1 flex-col gap-2 px-3 py-3">
					<h3 className="line-clamp-2 text-sm font-bold leading-5 text-slate-800">
						{event.title}
					</h3>
					<div className="flex flex-col gap-1">
						<div className="flex items-center gap-2">
							<CalendarIcon size={13} className="shrink-0 text-slate-500" />
							<span className="line-clamp-1 text-xs text-slate-600">
								{event.displayDate}
							</span>
						</div>
						{event.locationSummary && (
							<div className="flex items-center gap-2">
								<MapPinIcon size={13} className="shrink-0 text-slate-500" />
								<span className="line-clamp-1 text-xs text-slate-600">
									{event.locationSummary}
								</span>
							</div>
						)}
						{event.ticketPriceRange && (
							<div className="flex items-center gap-2">
								<img
									src={TicketIcon}
									alt="Ticket icon"
									className="h-3 w-3 shrink-0"
								/>
								<span className="line-clamp-1 text-xs text-slate-600">
									{event.ticketPriceRange}
								</span>
							</div>
						)}
					</div>
				</div>
			</a>
		</div>
	);
};

export default LandscapeItem;
